import { defineMessages } from 'react-intl';

const taxFeeCopy = defineMessages({
  vat: {
    id: 'inbox.current_details_main.vat_fee_copy',
    defaultMessage: 'Processing fee includes any applicable VAT charges.'
  },
  gst: {
    id: 'inbox.current_details_main.gst_fee_copy',
    defaultMessage: 'Processing fee includes any applicable GST charges.'
  },
  tax: {
    id: 'inbox.current_details_main.tax_fee_copy',
    defaultMessage: 'Processing fee includes any applicable tax charges.'
  }
});

export const intlTaxFeeCopy = {
  VAT: taxFeeCopy.vat,
  GST: taxFeeCopy.gst,
  other: taxFeeCopy.tax
}

const viewInvoicesLinkText = defineMessages({
  vat: {
    id: 'inbox.current_details_main.view_vat_invoices',
    defaultMessage: 'View VAT invoices.'
  },
  gst: {
    id: 'inbox.current_details_main.view_gst_invoices',
    defaultMessage: 'View GST invoices.'
  },
  tax: {
    id: 'inbox.current_details_main.view_tax_invoices',
    defaultMessage: 'View tax invoices.'
  }
});

export const intlViewInvoicesLinkText = {
  VAT: viewInvoicesLinkText.vat,
  GST: viewInvoicesLinkText.gst,
  other: viewInvoicesLinkText.tax
};

const viewInvoiceLinkTextWebview = defineMessages({
  vat: {
    id: 'inbox.current_details_main.view_vat_invoice',
    defaultMessage: 'View VAT invoice'
  },
  gst: {
    id: 'inbox.current_details_main.view_gst_invoice',
    defaultMessage: 'View GST invoice'
  },
  pst: {
    id: 'inbox.current_details_main.view_pst_invoice',
    defaultMessage: 'View PST invoice'
  },
  rst: {
    id: 'inbox.current_details_main.view_rst_invoice',
    defaultMessage: 'View RST invoice'
  },
  qst: {
    id: 'inbox.current_details_main.view_qst_invoice',
    defaultMessage: 'View QST invoice'
  },
  hst: {
    id: 'inbox.current_details_main.view_hst_invoice',
    defaultMessage: 'View HST invoice'
  },
  tax: {
    id: 'inbox.current_details_main.view_tax_invoice',
    defaultMessage: 'View tax invoice'
  }
});

export const intlViewInvoiceLinkTextWebview = {
  VAT: viewInvoiceLinkTextWebview.vat,
  GST: viewInvoiceLinkTextWebview.gst,
  PST: viewInvoiceLinkTextWebview.pst,
  RST: viewInvoiceLinkTextWebview.rst,
  QST: viewInvoiceLinkTextWebview.qst,
  HST: viewInvoiceLinkTextWebview.hst,
  other: viewInvoiceLinkTextWebview.tax
}
